import { Component } from "@angular/core";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { IEmployeeTrainingRecord } from "../shared/models/employee-training-record";
import { initial } from "lodash";
import { PpsUtilityService } from "../services/pps-utility.service";
import { BreakpointObserver, BreakpointState } from "@angular/cdk/layout";
import { SubSink } from "subsink";

@Component({
  selector: "pps-employee-training-record-warning",
  templateUrl: "./employee-training-record-warning.component.html"
})
export class EmployeeTrainingRecordWarningComponent{
  private gridApi;
  private subs = new SubSink();
  smallScreen = false;

  employeeTrainingRecords: IEmployeeTrainingRecord[] = [];
  totalCost: string = "";

  context:any = {};
  gridHeaders = [];
  gridOptions = {
    getRowId: param => param.data.id,
    defaultColDef: {
      resizable: true,
      floatingFilter: false
    }
  };

  constructor(
    private dialogRef: DynamicDialogRef,
    private dlgConfig: DynamicDialogConfig,
    private _util: PpsUtilityService,
    private breakpointObserver: BreakpointObserver) { 
      this.subs.sink = this.breakpointObserver.observe(['(min-width: 768px)'])
      .subscribe((state: BreakpointState) => {
        this.smallScreen = !state.matches;
      });      
  }

  ngOnInit(): void {
    this.initialize();
  }

  private initialize(){
    this.context = { componentParent: this };
    this.employeeTrainingRecords = this.dlgConfig.data.employeeTrainingRecords;

    let cost = 0;
    this.employeeTrainingRecords.forEach(t => cost += t.cost ?? 0);
    this.totalCost = this._util.formatCurrency(cost);

    this.gridHeaders = this.getColumnDefs();
  }

  onGridReady(params) {
    this.gridApi = params.api;
  }

  cancel(){
    this.dialogRef.close();
  }

  private getColumnDefs(){
    let colDefs = [
      {
        headerName: 'Course Title',
        field:'courseTitle',
        filter: true,
        sortable: true,
        flex: 1
      },
      {
        headerName: 'EnrollmentDate',
        field:'enrollmentDate',
        filter: true,
        sortable: true,
        width: 130,
        valueGetter: this.getDateValue
      },
      {
        headerName: 'Completion Date',
        field: 'completionDate',
        filter: true,
        sortable: true,
        width: 130,
        valueGetter: this.getDateValue
      },
      {
        headerName: 'Cost',
        field:'cost',
        filter: true,
        sortable: true,
        width: 100,
        cellStyle: this._util.getNumericCellStyle({borderRightColor:'#eeeeee'}),
        valueGetter: params => params.context.componentParent._util.formatCurrency(params.data[params.colDef.field])
      }
    ];

    if (this.smallScreen){
      colDefs.splice(0, 1);
    }

    return colDefs;
  }

  private getDateValue(params){
    if (params.data[params.colDef.field]){
      let value = params.context.componentParent._util.getDateString(params.data[params.colDef.field]);
      return value;
    }

    return "";
  }

}